<mat-card>


    <div *ngIf="getMatchedUrlValue() !== 'default'; else defaultMsg">

                    <div mat-dialog-title class="freemium-premium-modal__header">
                        <h2 class="freemium-premium-modal__title">{{ 'freemium-premium-modal.' + getMatchedUrlValue() + '_title' | translate }}</h2>
                    </div>

        <mat-card-content>

            <div class="freemium-premium-modal__content__thumbnail">
                <h3 class="freemium-premium-modal__content__thumbnail__title">
                    {{ 'freemium-premium-modal.' + getMatchedUrlValue() + '_thumb1_title' | translate }}
                </h3>
                <img class="freemium-premium-modal__content__thumbnail__img" src="assets/{{ brand }}/images/thumbs/group_freemium_1.png" alt="Illustration freemium premium lessons" >
            </div>
            <div class="freemium-premium-modal__content__thumbnail">
                <h3 class="freemium-premium-modal__content__thumbnail__title">
                    {{ 'freemium-premium-modal.' + getMatchedUrlValue() + '_thumb2_title' | translate }}
                </h3>
                <img class="freemium-premium-modal__content__thumbnail__img" src="assets/{{ brand }}/images/thumbs/group_freemium_2.png" alt="Illustration freemium premium lessons" >
            </div>
            <div class="freemium-premium-modal__content__thumbnail">
                <h3 class="freemium-premium-modal__content__thumbnail__title">
                    {{ 'freemium-premium-modal.' + getMatchedUrlValue() + '_thumb3_title' | translate }}
                </h3>
                <img class="freemium-premium-modal__content__thumbnail__img" src="assets/{{ brand }}/images/thumbs/group_freemium_3.png" alt="Illustration freemium premium lessons" >
            </div>

        </mat-card-content>
        <mat-card-actions>
            @if (displayBtnFreemiumPremiumAccess) {
                <button class="freemium-premium-modal__content__button"
                        (click)="openModalAccessPremium()">
                    <span>{{ 'toolbar.premium_upgrade' | translate }}</span>
                    <mat-icon svgIcon="toolbar__premium-action"></mat-icon>
                </button>
            }
        </mat-card-actions>

    </div>



    <ng-template #defaultMsg>
        <h1>{{ getMatchedUrlValue() }}</h1>
        Default message for unauthorized access to {{ data.attemptedUrl }}
    </ng-template>

</mat-card>